import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  onValidationError: EventEmitter<string[]> = new EventEmitter();
  onClearValidationErrors: EventEmitter<any> = new EventEmitter();
}
